var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "access_time",
    clipPath: "url(#clip0_3972_667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99169 2.16669C5.39169 2.16669 1.66669 5.90002 1.66669 10.5C1.66669 15.1 5.39169 18.8334 9.99169 18.8334C14.6 18.8334 18.3334 15.1 18.3334 10.5C18.3334 5.90002 14.6 2.16669 9.99169 2.16669ZM10 17.1667C6.31669 17.1667 3.33335 14.1834 3.33335 10.5C3.33335 6.81669 6.31669 3.83335 10 3.83335C13.6834 3.83335 16.6667 6.81669 16.6667 10.5C16.6667 14.1834 13.6834 17.1667 10 17.1667ZM9.81669 6.33335H9.76669C9.43335 6.33335 9.16669 6.60002 9.16669 6.93335V10.8667C9.16669 11.1584 9.31669 11.4334 9.57502 11.5834L13.0334 13.6584C13.3167 13.825 13.6834 13.7417 13.85 13.4584C14.025 13.175 13.9334 12.8 13.6417 12.6334L10.4167 10.7167V6.93335C10.4167 6.60002 10.15 6.33335 9.81669 6.33335Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3972_667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessTime);
export default __webpack_public_path__ + "static/media/access_time.1f801669669fb0c78135b1b833f6ad76.svg";
export { ForwardRef as ReactComponent };